import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 在此添加路由配置
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login2'),
    hidden: true,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/add',
    name: 'add',
    component: () => import('@/views/add'),
    hidden: true,
    meta: {
      title: '新增维保记录'
    }
  },
  {
    path: '/repair/:id?',
    name: 'repair',
    component: () => import('@/views/repair'),
    hidden: true,
    meta: {
      title: '新增报修'
    }
  },
  {
    path: '/records',
    name: 'records',
    component: () => import('@/views/InspectorRecords'),
    hidden: true,
    meta: {
      title: '巡检记录'
    }
  },
  {
    path: '/createQrCode',
    name: 'createQrCode',
    component: () => import('@/views/createQrCode'),
    hidden: true,
    meta: {
      title: '生成设备二维码'
    }
  },
  {
    path: '/improveInfo',
    name: 'improveInfo',
    component: () => import('@/views/qrcode/improveInfo'),
    hidden: true,
    meta: {
      title: '完善设备信息'
    }
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/InspectorDetails'),
    hidden: true,
    meta: {
      title: '巡检详情'
    }
  },
  {
    path: '/inspector',
    component: () => import('@/components/InspectorScan'),
    hidden: true,
    meta: {
      title: '巡检员扫描'
    }
  },
  {
    path: '/user',
    component: () => import('@/components/UserScan'),
    hidden: true,
    meta: {
      title: '普通用户扫描'
    }
  },
  {
    path: '',
    redirect: '/records',
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router